import React from 'react';

import ParameterSet from 'sharedreact/components/ParameterSet';
import TextField from 'sharedreact/components/TextField';
import ValidationForm, { ValidationProps } from 'sharedreact/components/ValidationForm';
import hideable from 'sharedreact/components/hideable';
import { translate } from 'sharedreact/utils/LanguageSupport';

import OpenIDConfig from 'workspaces/launcher/data/OpenIDConfig';

const SECRET_PLACEHOLDER: string = '12d456U8901m3456m8Y012s4567eCR123e456t90';

type Props = {
  openIDConfig: OpenIDConfig,
  className?: string,

  onChangeValue: (name: string, value: any) => void
} & ValidationProps;

class OpenIDOktaConfigPanel extends React.Component<Props> {
  override render (): React.ReactNode {
    const { openIDConfig, className,
      onChangeValue } = this.props;

    return (
      <ValidationForm className={className}>
        <ParameterSet useProvider={false}>
          <TextField id='ae_text_authentication_oidc_okahost'
            name='oktahost'
            value={openIDConfig.oktahost}
            label={translate('launcher.identityproviders.oidc.oktahost')}
            onChangeValue={onChangeValue}
            validations={['required']}
          />
          <TextField id='ae_text_authentication_oidc_clientid'
            name='clientId'
            value={openIDConfig.clientId}
            label={translate('launcher.identityproviders.oidc.clientid')}
            onChangeValue={onChangeValue}
            validations={['required']}
          />
          <TextField id='ae_text_authentication_oidc_clientsecret'
            name='clientSecret'
            value={openIDConfig.isClientSecretEdited || openIDConfig.isNew() ? openIDConfig.clientSecret : SECRET_PLACEHOLDER}
            label={translate('launcher.identityproviders.oidc.clientsecret')}
            type='password'
            onChangeValue={onChangeValue}
            validations={['required']}
            autoComplete='off'
          />
          <TextField id='ae_text_authentication_oidc_groupmembership'
            name='groupMembership'
            label={translate('launcher.identityproviders.oidc.groupmembership')}
            value={openIDConfig.groupMembership}
            placeholder={translate('launcher.identityproviders.oidc.groupmembership.placeholder')}
            onChangeValue={onChangeValue}
          />
        </ParameterSet>
      </ValidationForm>
    );
  }
}

export default hideable(OpenIDOktaConfigPanel);
